import { render, staticRenderFns } from "./AdminAddNameModal.vue?vue&type=template&id=5febf029"
import script from "./AdminAddNameModal.vue?vue&type=script&lang=js"
export * from "./AdminAddNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports